import React from "react"
import { useTranslation } from "react-i18next"

import { Modal, Spinner } from "components"
import classes from "./SssuUpdateModal.module.scss"

const SssuUpdateModal = (props) => {
  const { showHaveUpdateModal } = props

  const [t] = useTranslation()

  return (
    <Modal show={showHaveUpdateModal}>
      <div className={classes["container"]}>
        <div className={classes["title"]}>
          {t("وب_سایت_در_حال_بروز_رسانی_است_لطفا_منتظر_بمانید")}
        </div>

        <div className={classes["warning"]}>
          {t("لطفا از وبسایت خارج نشوید !")}
        </div>

        <Spinner
          size={30}
          color="red"
        />
      </div>
    </Modal>

  )
}

export default SssuUpdateModal